import { Platform } from 'react-native';
import { showInfo, showSuccess } from '../../shared/ui/appToast';

export const EMAIL_CONFIRM_PENDING_STORAGE_KEY = 'vuelto_pending_email_confirm_toast';

const TOAST_TITLE = 'Correo confirmado';
const TOAST_SUBTITLE = 'Tu cuenta ya está verificada. Podés seguir con la configuración.';

/** Lee `type` del hash (#) o del query (?), como en los redirects de Supabase Auth. */
export function getAuthCallbackFlowTypeFromUrl(url: string): string | null {
  try {
    const hashIndex = url.indexOf('#');
    if (hashIndex !== -1) {
      const fromHash = new URLSearchParams(url.slice(hashIndex + 1)).get('type');
      if (fromHash) return fromHash;
    }
    const parsed = new URL(url);
    const fromQuery = parsed.searchParams.get('type');
    if (fromQuery) return fromQuery;
  } catch {
    /* ignore */
  }
  return null;
}

/** Web: guarda intención si el hash aún no fue consumido (útil con detectSessionInUrl). */
export function captureWebEmailConfirmIntentFromLocation(): void {
  if (Platform.OS !== 'web' || typeof window === 'undefined') return;
  try {
    const hash = window.location.hash?.replace(/^#/, '') ?? '';
    if (!hash) return;
    if (new URLSearchParams(hash).get('type') === 'signup') {
      sessionStorage.setItem(EMAIL_CONFIRM_PENDING_STORAGE_KEY, '1');
    }
  } catch {
    /* ignore */
  }
}

export function clearEmailConfirmPendingStorage(): void {
  if (Platform.OS !== 'web' || typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(EMAIL_CONFIRM_PENDING_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** Si quedó pendiente (web), muestra el toast una vez. */
export function consumePendingEmailConfirmToastIfNeeded(): void {
  if (Platform.OS !== 'web' || typeof window === 'undefined') return;
  try {
    if (sessionStorage.getItem(EMAIL_CONFIRM_PENDING_STORAGE_KEY) !== '1') return;
    sessionStorage.removeItem(EMAIL_CONFIRM_PENDING_STORAGE_KEY);
    showSuccess(TOAST_TITLE, TOAST_SUBTITLE);
  } catch {
    /* ignore */
  }
}

/** Tras confirmar el mail por deep link / callback con `type=signup`. Evita duplicar con consume(). */
export function showEmailConfirmedAfterSignupToast(): void {
  clearEmailConfirmPendingStorage();
  showSuccess(TOAST_TITLE, TOAST_SUBTITLE);
}
